export enum TipoDeConfiguracaoId {
    LayoutPackUp = 'LayoutPackUp',
    IntegracaoConciliadorWcont = 'IntegracaoConciliadorWcont',
    IntegracaoFolhaNetWdp = 'IntegracaoFolhaNetWdp',
    PodeInformarTipoAtendimentoOperador = 'PodeInformarTipoAtendimentoOperador',
    PodeInformarTipoAtendimentoCliente = 'PodeInformarTipoAtendimentoCliente',
    EnviaConfirmacaoDocumento = 'EnviaConfirmacaoDocumento',
    QuantidadeDeNotificacoesDocumentos = 'QuantidadeDeNotificacoesDocumentos',
    IntervaloNotificacoesDocumentos = 'IntervaloNotificacoesDocumentos',
    DadosSMTP = 'DadosSMTP',
    TipoIntervaloTarefas = 'TipoIntervaloTarefas',
    TipoIntervaloResumoVendas = 'TipoIntervaloResumoVendas',
    TipoIntervaloCredenciaisInvalidas = 'TipoIntervaloCredenciaisInvalidas',
    ConfiguracaoCnd = 'ConfiguracaoCnd',
    CamposObrigatoriosCandidato = 'CamposObrigatoriosCandidato',
    OrientacaoDashboardCliente = 'OrientacaoDashboardCliente',
    DadosSocioCnd = 'DadosSocioCnd',
    ReceberHorarios = 'ReceberHorarios',
    AtendimentosComDelegacao = 'AtendimentosComDelegacao',
    PeriodicidadeSicronizacaoEstabelecimentos = 'PeriodicidadeSicronizacaoEstabelecimentos',
    EnvioAutomaticoDeNotificacaoDeDocumentos = 'EnvioAutomaticoDeNotificacaoDeDocumentos',
    EnvioAutomaticoDeNotificacaoDeDocumentosExcluidos = 'EnvioAutomaticoDeNotificacaoDeDocumentosExcluidos',
    AgendamentoDeFerias = 'AgendamentoDeFerias',
    BaixarRelatorioMaisBandeiras = 'BaixarRelatorioMaisBandeiras',
    IntegracaoCollectPorBandeira = 'IntegracaoCollectPorBandeira'
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/configuracao/tipo-de-configuracao-id.enum.ts